import React from "react";
import AppRouter from './app/router';
import ThemeProvider from './app/providers/ThemeProvider';

const App: React.FC = () => {
  return (
  <ThemeProvider>
    <div className="App">
      <AppRouter />
    </div>
  </ThemeProvider>
);
  // return <AppRoutes />;
}

export default App